<template>
    <div class="col-12 col-md-5 offset-md-1">
        <div class="form-group">
            <label for="medicare-part-a-effective-date"> Medicare Part A Effective Date </label>
            <DatePicker :getDate="getDate">
                <div class="input-group date datepickerInput">
                    <input
                        type="text"
                        name="medicare-part-a-effective-date"
                        class="form-control"
                        :value="formatDateInput(payer.MedicarePartAEffectiveDate)"
                        placeholder="MM/DD/YYYY"
                        autocomplete="off"
                    />
                    <div class="input-group-addon input-group-append">
                        <div class="input-group-text">
                            <i class="fa fa-calendar"></i>
                        </div>
                    </div>
                </div>
            </DatePicker>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import { formatDateInput } from "../../../../../../../common/vue-helpers/modifiers/value-modifier";

import DatePicker from "../../../../../../../resources-vue/vue-custom-elements/DatePicker/DatePicker.vue";
import { HospicePatientPayer } from "../../../../../../../resources-vue/vue-models/hospice-patient-payer";

export default defineComponent({
    components: {
        DatePicker
    },
    props: {
        payer: {
            type: HospicePatientPayer
        },
        requireAuthorizationChanged: {
            type: Function
        },

        getDate: {
            type: Function
        }
    },
    data() {
        return {
            formatDateInput
        };
    }
});
</script>
